<template>

    <card-list-item @click="">
        <template v-slot:icon><i class="far fa-fw" :class="['has-text-' + activity.data.type, activity.data.icon]"></i></template>
        <template v-slot:content>
            <div class="columns">
                <div class="column is-9">
                    <div class="tile-title" v-if="activity.data.message">{{activity.data.message}}</div>
<!--                    <div class="meta"><b-tag size="is-small" :type="getTypeColor(activity.data.method)" class="mr-2">{{activity.data.method}}</b-tag>{{activity.data.endpoint}}</div>-->
                </div>
                <div class="column">
                    <div class="meta" v-if="activity.data.user">
                        <i class="fas fa-user mr-2" v-if="activity.data.user"></i>{{activity.data.user.first_name}} {{activity.data.user.last_name}}
                    </div>
                </div>
            </div>

<!--            <json-viewer :value="activity" :expand-level="1"></json-viewer>-->
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">{{activity.date | moment('MMM D YYYY, h:mm a')}}</span>
            </div>
        </template>
        <template v-slot:details>

        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "../../TIER/components/CardListItem";
    export default {
        name: "ActivityUser",
        components: {CardListItem},
        props: ['activity'],
        data() {
            return {
                titles
            };
        },
        methods: {
            getLevelColor: function() {
                if (this.activity.data.level === 'info') {
                    return 'is-success';
                } else if (this.activity.data.level === 'warn') {
                    return 'is-warning';
                } else if (this.activity.data.level === 'error') {
                    return 'is-danger';
                }
            }
        }
    };

    let titles = {
        '/app/registrations/': 'Conference Registrations',
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
